import { createSlice } from "@reduxjs/toolkit";
import {
  PendingRequestData,
  PendingRequestInitialStatus,
} from "../../../../types/eventManage/pendingRequest";
import {
  deleteCampaignAsync,
  deleteEventAsync,
  deleteWebinarAsync,
  getAllPendingRequestAsync,
} from "./pendingRequestApi";

const initialState: PendingRequestInitialStatus<PendingRequestData> = {
  loading: false,
  manageLoading: false,
  PendingRequestList: [],
  countPendingRequest: 0,
};

const pendingRequestSlice = createSlice({
  name: "admin-pendingRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllPendingRequestAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllPendingRequestAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.PendingRequestList = action.payload.data;
        state.countPendingRequest = action.payload.length;
      })
      .addCase(getAllPendingRequestAsync.rejected, (state) => {
        state.loading = false;
        state.PendingRequestList = [];
        state.countPendingRequest = 0;
      });

    // Event
    builder
      .addCase(deleteEventAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEventAsync.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteEventAsync.rejected, (state) => {
        state.loading = false;
      });

    // Webinar
    builder
      .addCase(deleteWebinarAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWebinarAsync.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteWebinarAsync.rejected, (state) => {
        state.loading = false;
      });

    // Campaign
    builder
      .addCase(deleteCampaignAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCampaignAsync.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteCampaignAsync.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default pendingRequestSlice;
